import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

const OnChainPOR = () => {
  return (
    <>
      <Helmet>
        <title>On-Chain Proof of Reserves - Proof of Reserves Auditor</title>
        <meta name="description" content="Direct blockchain verification through smart contract integration." />
      </Helmet>

      <div className="service-page">
        <section className="relative section-padding bg-gradient-to-br from-primary to-primary-800 text-white">
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src="/cpaservices.jpg"
              alt="CPA Services Background"
              className="w-full h-full object-cover"
            />
            {/* Dark overlay for text readability */}
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          </div>
          <div className="container-custom relative z-10">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">On-Chain Proof of Reserves</h1>
            <p className="text-xl text-gray-200 max-w-3xl">
              Transparent, publicly-verifiable proof through blockchain verification and smart contract integration
            </p>
          </div>
        </section>

        <section className="section-padding bg-white">
          <div className="container-custom max-w-4xl">
            <h2 className="section-title">Overview</h2>
            <p className="text-lg text-gray-600 mb-6">
              Our On-Chain Proof of Reserves provides direct blockchain verification of reserve addresses through smart contract integration. This approach delivers transparent proof that can be independently confirmed by anyone, anytime, directly on the blockchain.
            </p>

            <h2 className="section-title mt-12">Key Features</h2>
            <ul className="list-disc list-inside text-lg text-gray-600 space-y-2 mb-8">
              <li>Smart contract-based verification</li>
              <li>Publicly accessible on-chain data</li>
              <li>Real-time reserve monitoring</li>
              <li>Automated verification processes</li>
              <li>Integration with DeFi protocols</li>
              <li>Chainlink oracle integration</li>
            </ul>

            <h2 className="section-title mt-12">How It Works</h2>
            <p className="text-lg text-gray-600 mb-6">
              Reserve data is published directly to the blockchain through smart contracts, making it permanently accessible and verifiable. Integration with oracle networks like Chainlink enables off-chain reserve data to be brought on-chain for use in decentralized applications and smart contracts.
            </p>

            <h2 className="section-title mt-12">Benefits</h2>
            <ul className="list-disc list-inside text-lg text-gray-600 space-y-2 mb-8">
              <li>Maximum transparency through public blockchain</li>
              <li>24/7 real-time verification capability</li>
              <li>Integration with DeFi ecosystems</li>
              <li>Automated circuit breakers and controls</li>
              <li>Enhanced user confidence and trust</li>
              <li>Reduced audit overhead costs</li>
            </ul>

            <h2 className="section-title mt-12">Use Cases</h2>
            <p className="text-lg text-gray-600 mb-4">
              On-chain proof of reserves is ideal for:
            </p>
            <ul className="list-disc list-inside text-lg text-gray-600 space-y-2 mb-8">
              <li>Stablecoin issuers seeking maximum transparency</li>
              <li>DeFi protocols requiring reserve verification</li>
              <li>Platforms with on-chain assets</li>
              <li>Projects requiring automated compliance</li>
            </ul>

            <div className="mt-12 text-center">
              <Link to="/contact" className="btn-primary">
                Request a Quote
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default OnChainPOR